import PropTypes from "prop-types";
import React from "react";

import BaseLink from "~/components/links/BaseLink";

import Image from "~/components/Image";

const ImageLink = ({ image, to }) => (
    <BaseLink {...{ to }}>
        <Image {...image} />
    </BaseLink>
);

ImageLink.propTypes = {
    image: PropTypes.shape({
        sourceUrl: PropTypes.string.isRequired,
        alt: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
    to: PropTypes.string.isRequired,
};

export default ImageLink;
